var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect } from "react";
import { useLazyQuery } from "@atlassiansox/microscopekit";
import { ResilienceFaults, RdsListForAServiceQuery } from "../../../../../graphql";
export var useRdsListForAService = function (faultExecution, service, environment) {
    var _a;
    var _b = __read(useLazyQuery(RdsListForAServiceQuery), 2), getData = _b[0], _c = _b[1], loading = _c.loading, data = _c.data;
    var options = (_a = data === null || data === void 0 ? void 0 : data.rdsListForAService) !== null && _a !== void 0 ? _a : [];
    var defaultOption = options[0];
    useEffect(function () {
        if (faultExecution === ResilienceFaults.reboot_rds) {
            getData({
                variables: {
                    service: service,
                    environment: environment
                }
            });
        }
    }, [faultExecution, environment, getData, service]);
    return {
        options: options,
        isLoading: loading,
        defaultOption: defaultOption
    };
};
